import r, { createContext as l, useContext as d } from "react";
var n = l(null);
n.displayName = "OpenClosedContext";
var i = function (e) {
  return e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e;
}(i || {});
function u() {
  return d(n);
}
function c(_ref) {
  var o = _ref.value,
    t = _ref.children;
  return r.createElement(n.Provider, {
    value: o
  }, t);
}
function s(_ref2) {
  var o = _ref2.children;
  return r.createElement(n.Provider, {
    value: null
  }, o);
}
export { c as OpenClosedProvider, s as ResetOpenClosedProvider, i as State, u as useOpenClosed };